// Размер топов категорий и позиций — как на прежнем экране.
export const STATS_TOP_LIMIT = 10;
